import React from "react";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";
import IconTag from "../GetIcon";

const IconToggelNav = (props) => {
    
    return (
        <>
            {props?.v.status && !Object.values(props.menuList).some((submenu) => submenu.parent_menu_code === props?.v.code) && !(props?.v.location == "sub_menu" && !props?.v.parent_menu_code) ? (
                <li key={props.v.code} className="icon-toggel-menu">
                    <NavLink to={props?.customLink} onMouseOver={() => props.mouseOver(props?.v.code)} data-tooltip={props?.v.name}>
                        {props?.v.menu_class ? (
                            <>
                                <span>
                                    <IconTag iconTagName={props?.v.menu_class} />
                                </span>
                            </>
                        ) : props?.v.menu_icon?.base_path ? (
                            <img
            loading="lazy"
                                src={
                                    props.ftpPath +
                                    props?.v.menu_icon?.base_path +
                                    props?.v.menu_icon?.system_file_name
                                }
                            />
                        ) : null}
                    </NavLink>
                </li>
            ) : null}
        </>
    );
};

IconToggelNav.propTypes = {
    preGlobalFilteredRows: PropTypes.any,
};

export default withTranslation()(IconToggelNav);
